import styled from "styled-components";
const Wrapper = styled.section`
  width: 80%;
  padding: 20px;
  color: white;
  border-top: 2px solid #4debc67a;
  margin-top: 40px;
  @media only screen and (max-width: 600px) {
    width: 100%;
    margin-top: 10px;
  }
`;
export default Wrapper;